export default "__VITE_ASSET__DnQ0$Qbp__"